import { render, staticRenderFns } from "./LpuLoyaltyProgramBadge.vue?vue&type=template&id=2e8e6559&"
import script from "./LpuLoyaltyProgramBadge.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuLoyaltyProgramBadge.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8e6559')) {
      api.createRecord('2e8e6559', component.options)
    } else {
      api.reload('2e8e6559', component.options)
    }
    module.hot.accept("./LpuLoyaltyProgramBadge.vue?vue&type=template&id=2e8e6559&", function () {
      api.rerender('2e8e6559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramBadge.vue"
export default component.exports